import { useLocation, useParams } from "react-router-dom";

type UseBasePathReturn = {
  basePath: string;
  path: (url: string) => string;
};

/**
 * Returns the base path including language and app prefix (e.g., "/en/admin")
 * and a path builder function that prepends the base path to any URL.
 *
 * @example
 * const { basePath, path } = useBasePath();
 * // basePath: "/en/admin"
 * // path('controls/forms'): "/en/admin/controls/forms"
 */
export function useBasePath(): UseBasePathReturn {
  const { language } = useParams();
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const langIndex = pathSegments.findIndex((seg) => seg === language);
  const appPrefix = pathSegments[langIndex + 1];

  const basePath = `/${language}/${appPrefix}`;

  const path = (url: string): string => {
    return `${basePath}/${url}`.replace(/\/+/g, "/");
  };

  return {
    basePath,
    path,
  };
}
